import { render, staticRenderFns } from "./addResourceStoreType.vue?vue&type=template&id=2623cf0d&scoped=true"
import script from "./addResourceStoreType.vue?vue&type=script&lang=js"
export * from "./addResourceStoreType.vue?vue&type=script&lang=js"
import style0 from "./addResourceStoreType.vue?vue&type=style&index=0&id=2623cf0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2623cf0d",
  null
  
)

export default component.exports